import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { PromotionDetails } from '../types/documentVersion.types';

interface SuccessToastProps {
  isVisible: boolean;
  promotionDetails: PromotionDetails | null;
  onClose: () => void;
}

export const SuccessToast: React.FC<SuccessToastProps> = ({
  isVisible,
  promotionDetails,
  onClose,
}) => {
  if (!isVisible || !promotionDetails?.toVersion) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 shadow-lg max-w-sm">
        <div className="flex items-start space-x-3">
          <CheckIcon className="h-5 w-5 text-green-600 dark:text-green-400 mt-0.5" />
          <div className="flex-1">
            <h4 className="text-sm font-medium text-green-900 dark:text-green-200">
              Version Promotion Successful
            </h4>
            <p className="text-sm text-green-800 dark:text-green-300 mt-1">
              {promotionDetails.toVersion.version_number} is now the active version.
            </p>
            <p className="text-xs text-green-700 dark:text-green-400 mt-2">
              All version history has been preserved.
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-green-400 hover:text-green-600 dark:hover:text-green-300"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};